module.exports = __webpack_public_path__ + "img/trash2.bb8da84f.svg";